import { memo } from "react";
import "./carouselEndCard.css";

export const CarouselEndCard = memo(({ onRestart }) => (
  <div
    className="carousel-end-card"
    role="button"
    tabIndex={0}
    onClick={onRestart}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onRestart();
      }
    }}
  >
    <span className="carousel-end-icon">
      <i className="fa-solid fa-rotate-left" />
    </span>
    <p className="carousel-end-text">You have reached the end</p>
  </div>
));
